/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import DoctorsDataContent from "components/content/DoctorsDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { FC } from "react";

/**
 * Doctor/provider management page.
 * 
 * Features:
 * - Paginated list of all doctors/medical providers
 * - Provider profile information (specialties, credentials)
 * - Schedule and availability management
 * - Provider performance metrics
 * - Quick actions (view, edit, deactivate providers)
 * - Integration with appointment scheduling
 * 
 * @returns Doctors list page component
 */
const DoctorsPage: FC = () => {
  return (
    <DefaultDashboardLayout>
      <DoctorsDataContent />
    </DefaultDashboardLayout>
  );
};

export default DoctorsPage;

